import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { Control, Form, actions } from 'react-redux-form';

import Button from '../Button';
import BaseDetailScreen from '../BaseDetailScreen';
import LabeledRow from '../Invest/components/LabeledRow';
import {
  PLACEHOLDER_OPT,
  tradeSecurityTransferPath,
} from '../Forms/Schemas/baseRrf';
import Select, { SELECT_STYLE } from '../Forms/Controls/Select';
import InputField from '../Forms/Controls/Field';
import CurrencyField from '../Forms/Controls/CurrencyField';
import Currency from '../Currency';
import { myIPOAccountID, getAccountOptsFromBankLinks } from '../TransferFunds/utils';
import {
  fetchAccountBankLinks,
} from '../../actions/bankLinks';
import { TRADE_TYPE } from '../SecurityTrade';

import {
  tradeSecurityTransferInfo,
} from '../../actions';

import '../Invest/InvestmentViews/styles.css';

const Big = require('big.js/big.js');

class OrderPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transferOpts: {},
    };
  }

  async componentDidMount() {
    const bigCashBal = new Big(this.props.cashBalance).round(2, 0);
    const bigReqAmt = new Big(this.props.requestedDollarAmount);
    if (bigCashBal.gte(bigReqAmt.toFixed(2)) ||
      this.props.tradeDir === TRADE_TYPE.SELL) {
      // clear transfer funds info in case it was there froma  previous trade
      await this.props.tradeSecurityTransferInfo({});
      this.props.onNext();
    }

    this.props.fetchAccountBankLinks(this.props.accountNumber);
  }

  componentWillReceiveProps = (nextProps) => {
    const { accountBankLinks } = nextProps;
    const newOpts = getAccountOptsFromBankLinks(accountBankLinks);

    // remove My IPO from the available options
    delete newOpts[myIPOAccountID];
    // if account is deleted after already being selected for order
    // then this resets value to PLACEHOLDER_OPT
    if (this.props.transferFundsForm.from &&
     !newOpts[this.props.transferFundsForm.from]) {
      this.props.resetTransferAccount(PLACEHOLDER_OPT);
    }

    this.setState({
      transferOpts: {
        ...newOpts,
      },
    });
  }

  onSubmit = async () => {
    const {
      transferFundsForm,
    } = this.props;
    const {
      transferAmount,
      from,
    } = transferFundsForm;
    await this.props.tradeSecurityTransferInfo({
      transferAmount,
      from,
    });
    this.props.onNext();
  }

  render() {
    const bigCashBal = new Big(this.props.cashBalance).round(2, 0);
    const bigReqAmt = new Big(this.props.requestedDollarAmount);
    const orderDifference = bigReqAmt.minus(bigCashBal);
    const accountSelectionField = {
      model: '.from',
      RRFComp: Control,
      control: {
        component: Select,
        selectStyle: SELECT_STYLE.BLUE,
        errors: {
          required: val => !val || !val.length || val === PLACEHOLDER_OPT,
        },
      },
      error: {
        messages: {
          required: 'Please select an account to transfer from.',
        },
      },
    };

    const transferAmountField = {
      model: '.transferAmount',
      RRFComp: Control,
      control: {
        component: CurrencyField,
        parser: val => val && val.toString().replace(/\$|,/g, ''),
        placeholder: '$0.00',
        errors: {
          required: val => !val || !val.length,
          satisfiesOrder: (val) => {
            if (val) {
              const bigVal = new Big(val);
              return (val && (bigVal.round(2, 0).lt(orderDifference.round(2, 0))));
            }
            return false;
          },
        },
      },
      error: {
        messages: {
          required: 'Please enter the amount to be transferred.',
          satisfiesOrder: `The transfer amount must be at least $${orderDifference.toFixed(2)}`,
        },
      },
    };

    return (
      <div>
        <BaseDetailScreen
          backLabel="Edit Order"
          backTo={this.props.backTo}
          pageHeading="Transfer Details"
          pageSubheading="Your current cash balance is less than the order amount. Would you like to transfer additional funds to your My IPO account now?"
        >
          <div styleName="main">
            <LabeledRow
              isCurrency
              label="Order Amount"
              value={Number.parseFloat(bigReqAmt.toFixed(2), 10)}
            />
            <LabeledRow
              isCurrency
              label="Cash Balance"
              value={Number.parseFloat(bigCashBal.toFixed(2), 10)}
            />
            <div styleName="breakLine" />
            <Form
              model={tradeSecurityTransferPath}
              onSubmit={this.onSubmit}
              disabled={this.props.bankLinksFetching}
            >
              <InputField
                key={accountSelectionField.model}
                fieldProps={accountSelectionField}
              >
                {Object.keys(this.state.transferOpts).sort(a => (
                  a === PLACEHOLDER_OPT ? -1 : 1)).map(key => (
                    <option key={key} value={key}>
                      {this.state.transferOpts[key]}
                    </option>
                  ))}
              </InputField>
              <div styleName="transferLabel">Transfer Amount</div>
              <InputField
                key={transferAmountField.model}
                fieldProps={transferAmountField}
              />
              <div styleName="cashAvailableRow">
                <div styleName="cashAvailable">
                  Additional Funds Required
                </div>
                <Currency
                  styleName="cashAvailable"
                  amount={Number.parseFloat(orderDifference.toFixed(2))}
                />
              </div>
              <div styleName="submitButtonContainer">
                <Button type="submit">
                  Review Transfer
                </Button>
              </div>
            </Form>
          </div>
        </BaseDetailScreen>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  accountNumber: state.currentAccount,
  accountBankLinks: get(state, `accountBankLinks.[${state.currentAccount}].data`, []),
  tradeSecurityForm: get(state, 'tradeSecurityForm.tradeSecurity'),
  transferFundsForm: get(state, 'tradeSecurityForm.tradeSecurityTransferFunds'),
  bankLinksFetching: get(state, `acccountBankLinks.[${state.currentAccount}].isFetching`, false),
  cashBalance: Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.balanceAvailableForT1Trades', 0.00)),
  requestedDollarAmount: Number.parseFloat(get(state, 'tradeSecurityInfo.tradeInfo.total')),
});

const mapDispatchToProps = dispatch => ({
  tradeSecurityTransferInfo: (...args) => (dispatch(tradeSecurityTransferInfo(...args))),
  fetchAccountBankLinks: (...args) => (dispatch(fetchAccountBankLinks(...args))),
  resetTransferAccount: defaultAccount => (dispatch(actions.change(`${tradeSecurityTransferPath}.from`, defaultAccount))),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderPayment);



// WEBPACK FOOTER //
// ./src/components/SecurityTrade/OrderPayment.js